class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.videoElem = this.querySelector('video');
    this.playButton = this.querySelector('.play-button');

    if (!this.videoElem || !this.playButton) return;

    this.playButton.addEventListener('click', this.handlePlayButton.bind(this));

    this.videoElem.addEventListener('pause', () => {
      this.videoElem.classList.remove('video-play');
    });

    this.videoElem.addEventListener('ended', () => {
      this.videoElem.classList.remove('video-play');
    });
  }

  async playVideo() {
    try {
      await this.videoElem.play();
      this.videoElem.classList.add('video-play');
    } catch (err) {}
  }

  handlePlayButton() {
    if (this.videoElem.paused) {
      this.playVideo();
    } else {
      this.videoElem.pause();
      this.videoElem.classList.remove('video-play');
    }
  }
}

customElements.define('custom-video', CustomVideo);